import { email } from 'vee-validate/dist/rules';
import { ValidatorUtils } from './utils';

export const emailValidator = {
    ...email,
    message(field: string) {
        return `${ValidatorUtils.prettifyName(field)} is not valid email`;
    },
};
